// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2eUiC","productName":"Table_productName__2eDwW"};